export const updateValueToReal = (value) => {
  const isNotANumber = typeof value != 'number';

  if (isNotANumber) {
    return parseInt(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }
  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
};
